import ComplexCaseSolution from "./ComplexCaseSolution.vue";
export default ComplexCaseSolution;
